<div>
  <div class="title title--big">Компании</div>
</div>

<div class="pos-r">
  <app-loader *ngIf="dataLoading"></app-loader>

  <div class="mt-32 pt-8">
    <div class="grid grid--va-middle">
      <div class="grid__box">
        <app-role-access [action]="'disable'" [permission]="'partnership.add'" [placement]="'bottom-left'">
          <button data-role-element type="button" class="button" (click)="companyCreate()" id="appCompanyCreate">Добавить новую компанию</button>
        </app-role-access>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid">
          <div class="grid__box grid__box--size-min">Операции со справочником:</div>
          <div class="grid__box grid__box--size-min">
            <app-role-access [action]="'disable'" [permission]="'partnership.export'" [placement]="'bottom-right'">
              <button data-role-element (click)="exportCompanies()" id="appCompanyExport">
                <a class="link link--dotted-gray-dark">Экспорт</a>
              </button>
            </app-role-access>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-companies-filter [filter]="filterCompanies"></app-companies-filter>
  <app-companies-list [filter]="filterCompanies" [companiesTable]="companiesTable" [dataLoading]="dataLoading"></app-companies-list>
</div>
